/* Applied-code chips in the basket (10 Sep 2026).

   Mechanics, all verified against the live store on 10 Sep rather than taken from the docs:
     - POST /cart/update.js {"discount":"CODE"} applies a code and returns the cart. No reload.
     - Codes ACCUMULATE. Posting a second code keeps the first.
     - {"discount":""} clears ALL of them. It is the only removal route found; /discount/ with an
       empty code does nothing. So removing one chip means clearing and re-applying the others,
       which is what removeOne() does.
     - An inapplicable code produces no discount application, so Liquid never sees it. Everything
       here therefore comes from /cart.js, whose discount_codes carries {code, applicable}.

   Renders into snippets/dn-cart-codes.liquid, on the cart page and in the drawer. Re-reads after
   every cart change, because a code that did not apply at S$28 does apply at S$31. */
(function () {
  'use strict';

  function root() { return document.querySelector('[data-dn-codes]'); }
  function terms() {
    var el = document.querySelector('[data-dn-code-terms]');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  }

  /* The terms for one code: its own key, else a key ending in * whose prefix it carries (12 Sep 2026:
     referral codes are FRIEND- plus six characters made on demand, so the block lists "FRIEND-*"). */
  function term(map, code) {
    var c = String(code || '').toUpperCase();
    if (map[c]) return map[c];
    for (var k in map) {
      if (k.charAt(k.length - 1) === '*' && c.indexOf(k.slice(0, -1)) === 0) return map[k];
    }
    return null;
  }

  function getCart() {
    return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function post(discount) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: discount }),
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  /* All-or-nothing removal: clear every code, then put the survivors back one at a time. If a
     re-apply fails the shopper is left with fewer codes than they had, so the survivors go back
     before the UI is redrawn and the redraw reads the real cart rather than what we hoped for. */
  function removeOne(code, codes) {
    var keep = codes.filter(function (c) { return c.code !== code; }).map(function (c) { return c.code; });
    var chain = post('');
    keep.forEach(function (c) { chain = chain.then(function () { return post(c); }); });
    return chain.then(render);
  }

  function chip(c, codes, map) {
    var li = document.createElement('li');
    if (c.applicable) {
      li.className = 'dn-code dn-code--on';
      var name = document.createElement('span');
      name.className = 'dn-code__name';
      name.textContent = c.code;
      /* What the code actually does, beside the code itself (11 Sep 2026: "only show
         voucher that is applied with mechanic"). A bare code says nothing about the saving it is
         making; the mechanic comes from the terms block, so it cannot drift from vouchers.ts
         without someone noticing the blank. */
      var t = term(map, c.code);
      var mech = t && t.mechanic;
      if (mech) {
        var m = document.createElement('span');
        m.className = 'dn-code__mechanic';
        m.textContent = mech;
        name.appendChild(m);
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dn-code__remove';
      btn.setAttribute('aria-label', 'Remove ' + c.code);
      btn.textContent = 'Remove';
      btn.addEventListener('click', function () {
        btn.disabled = true;
        removeOne(c.code, codes);
      });
      li.appendChild(name);
      li.appendChild(btn);
    } else {
      return null;   /* codes that did not apply are not shown; see render() */
    }
    return li;
  }

  /* One voucher per basket (ADR-007, 11 Sep 2026). Every voucher is set in Shopify not to combine
     with another, so a second one would sit in the cart doing nothing while the first kept
     applying - and which one Shopify keeps is not ours to predict. So the basket decides, in the
     open: the card just clicked wins, otherwise the one already taking money off, and the other
     is taken out. Only codes in the terms block count; anything else is left alone. */
  var replaced = null;
  var fixes = 0;   /* at most twice a page: if the cart will not let go of a code, stop, don't loop */
  function oneVoucher(codes, map) {
    var ours = codes.filter(function (c) { return term(map, c.code); });
    if (ours.length < 2 || fixes >= 2) return null;
    fixes++;
    var keep = null;
    for (var i = 0; i < ours.length; i++) {
      if (attempted && String(ours[i].code).toUpperCase() === attempted) keep = ours[i];
    }
    if (!keep) keep = ours.filter(function (c) { return c.applicable; })[0] || ours[ours.length - 1];
    var drop = ours.filter(function (c) { return c !== keep; }).map(function (c) { return c.code; });
    var survivors = codes.filter(function (c) { return drop.indexOf(c.code) < 0; }).map(function (c) { return c.code; });
    replaced = { kept: keep.code, dropped: drop };
    var chain = post('');
    survivors.forEach(function (c) { chain = chain.then(function () { return post(c); }); });
    return chain;
  }

  function render() {
    var host = root();
    if (!host) return Promise.resolve();
    return getCart().then(function (cart) {
      var list = host.querySelector('[data-dn-codes-list]');
      if (!list) return;
      var codes = (cart && cart.discount_codes) || [];
      var fixing = oneVoucher(codes, terms());
      if (fixing) return fixing.then(render);
      /* Only the ones actually taking money off (11 Sep 2026). The block used to name every
         code the shopper had entered, including the ones doing nothing and why. That is a real
         trade: a code typed in that never appears again gives no feedback at all, and /cart.js is
         the only place a failed code is visible. It is the owner's call, and it is recorded here so
         the next person knows the line was removed rather than never written. */
      var on = codes.filter(function (c) { return c.applicable; });
      list.textContent = '';
      /* Rebuilt from the cart every time, so it can never assert a condition the basket has since
         met — the line goes on its own the moment the code starts applying. */
      var stale = host.querySelectorAll('.dn-code-note');
      for (var s = 0; s < stale.length; s++) stale[s].remove();
      var map = terms();
      var note = attemptNote(codes, map) || swapNote(codes);
      if (note) host.insertBefore(note, host.firstChild);
      if (!on.length && !note) { host.hidden = true; return; }
      on.forEach(function (c) {
        var li = chip(c, codes, map);
        if (li) list.appendChild(li);
      });
      host.hidden = false;
    });
  }

  /* The one thing the applied-only chip list cannot say.

     11 Sep 2026: "only show voucher that is applied with mechanic". That is right for the
     steady state, but it left a hole - vouchers are not typed here, they are clicked, and clicking
     a card you do not yet qualify for applies nothing and says nothing. /cart.js was the only place
     the failure was visible.

     So the card writes dn_code=<code> onto its redirect target and we remember it for this page.
     Only that ONE code is ever named; every other inapplicable code stays unnamed, so the list
     itself is unchanged. The param is stripped from the URL as soon as it is read, so a refresh or
     a back-button return does not re-accuse a code the shopper has since satisfied.

     It is remembered rather than acted on once, because render() re-runs on every dn:cart event -
     the first of which lands moments after load. Writing the line straight into the DOM raced that
     redraw and the message disappeared about half the time. render() owns it now: it re-reads the
     cart each time and decides, so the line survives a redraw and, better, clears itself the moment
     the basket reaches the minimum and the chip takes its place. */
  var attempted = (function () {
    try {
      var v = new URLSearchParams(location.search).get('dn_code');
      if (!v) return null;
      var url = new URL(location.href);
      url.searchParams.delete('dn_code');
      history.replaceState(null, '', url.pathname + url.search + url.hash);
      return v.toUpperCase();
    } catch (e) { return null; }   /* no URLSearchParams/history: the chips still work */
  })();

  /* The line for the attempted code, or null when there is nothing honest to say. Nothing when it
     applied, and nothing when the code is absent from the cart entirely: absent means Shopify
     rejected it outright (expired, disabled, never existed), and naming a condition we cannot check
     would be a guess. A wrong reason is worse than no reason. */
  function attemptNote(codes, map) {
    if (!attempted) return null;
    var hit = null;
    for (var i = 0; i < codes.length; i++) {
      if (String(codes[i].code).toUpperCase() === attempted) { hit = codes[i]; break; }
    }
    if (!hit || hit.applicable) return null;
    var t = term(map, attempted);
    var note = document.createElement('p');
    note.className = 'dn-code-note';
    note.setAttribute('role', 'status');
    note.textContent = t && t.condition
      ? attempted + ' is not applied yet: ' + t.condition + '.'
      : attempted + ' has not applied to this basket.';
    return note;
  }

  /* Say what oneVoucher() did, once it has, and only while the kept code is still in the cart. */
  function swapNote(codes) {
    if (!replaced || !replaced.dropped.length) return null;
    var still = codes.some(function (c) { return c.code === replaced.kept; });
    if (!still) return null;
    var note = document.createElement('p');
    note.className = 'dn-code-note';
    note.setAttribute('role', 'status');
    note.textContent = 'One voucher per basket, so ' + replaced.kept + ' replaced ' + replaced.dropped.join(' and ') + '.';
    return note;
  }

  function start() {
    if (!root()) return;
    render();
    /* dn-cart.js fires dn:cart after every change it makes, and swaps the summary section, which
       replaces this block — so re-render on the event rather than binding once to the node. */
    document.addEventListener('dn:cart', function () { render(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
